import { atom } from "recoil"
export const readSystemInformationsState = atom<Set<string>>({
  key: "atoms/bottomTab/readSystemInformationsState",
  default: new Set<string>(),
})
